export class KeywordConstant {
  public static keywordRel = 'skosxl:altLabel';
  public static keywordProperty = 'skosxl:literalForm';
  public static keywordDefProperty = 'skos:definition';
  public static keywordContentProperty = 'content';
  public static keywordAboutProperty = 'about';
  public static keywordLabel = 'skosxl:Label';
  public static keywordHighlight = 'highlight-keyword-onscroll';
}
